export default __webpack_public_path__ + "static/Historial_de_Siniestros-831f6095daabc55335d40275019415cd.png";